import TermsPage from "./components/TermsPage.svelte";
import { wrap } from "svelte-spa-router/wrap";
import Home from "./Home.svelte";

// Export the route definition object
export default {
  // Exact path
  "/": Home,
  "/privacy-policy": wrap({
    component: TermsPage,
    // Static props
    props: {
      pathToFile: "./PRIVACY_POLICY_DATA.json",
    },
  }),
  "/security": wrap({
    component: TermsPage,
    // Static props
    props: {
      pathToFile: "./SECURITY_DATA.json",
    },
  }),
  "/terms-of-use": wrap({
    component: TermsPage,
    // Static props
    props: {
      pathToFile: "./TERMS_OF_USE_DATA.json",
    },
  }),
};
